import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  LinearProgress,
} from '@material-ui/core';
import ReturnMaterialQuantityInput from './ReturnMaterialQuantityInput';
import { setReturnMaterialsDialog } from '../redux';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { returnMaterialsToWarehouse } from '../../helperFunctions';

const ReturnMaterialsDialog = ({ onClose }) => {
  const dispatch = useDispatch();
  const data = useSelector(state => state.tasks.data);
  // const showTaskDetails = useSelector(state => state.tasks.showTaskDetails);
  // const task = data.tasks.find(x => x.id === showTaskDetails.taskId);
  const returnMaterialDialog = useSelector(state => state.tasks.returnMaterialsDialog);
  const returnedMaterials = useSelector(state => state.tasks.returnedMaterials);
  const { width } = useWindowDimensions();
  const smallerFontSize = width <= 500 ? '3.5vw' : '18px';

  const getMaterialsToMap = () => {
    return data.materials.filter(x => x.materialId.toLowerCase().indexOf('dismantled') !== -1);
  };

  if (!returnMaterialDialog?.open) {
    return null;
  }

  return (
    <Dialog open={returnMaterialDialog.open} onClose={onClose}>
      <DialogTitle>Връщане на устройства</DialogTitle>
      {data.isReturnToWarehouseLoading ? (
        <LinearProgress />
      ) : (
        <>
          <DialogContent>
            <Typography gutterBottom component="h2">
              Сигурни ли сте че искате да върнете устройствата към склад?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                dispatch(
                  setReturnMaterialsDialog({
                    open: false,
                  })
                );
              }}
              color="primary"
              variant="outlined"
              style={{ border: '1px solid red' }}
            >
              Не
            </Button>
            <Button
              onClick={() => returnMaterialsToWarehouse(returnedMaterials, data, dispatch)}
              color="primary"
              variant="outlined"
              style={{ border: '1px solid red' }}
              autoFocus
            >
              Да
            </Button>
          </DialogActions>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{
                      fontSize: smallerFontSize,
                      paddingRight: '1px',
                      lineHeigth: '1.1',
                    }}
                    size="small"
                  >
                    Име
                  </TableCell>
                  <TableCell
                    style={{
                      fontSize: smallerFontSize,
                      paddingRight: '1px',
                      lineHeigth: '1.1',
                    }}
                    size="small"
                  >
                    Материал
                  </TableCell>
                  <TableCell
                    style={{
                      fontSize: smallerFontSize,
                      paddingRight: '1px',
                      lineHeigth: '1.1',
                    }}
                    size="small"
                  >
                    Сер. номер
                  </TableCell>
                  <TableCell
                    style={{
                      fontSize: smallerFontSize,
                      paddingRight: '1px',
                      lineHeigth: '1.1',
                    }}
                    size="small"
                  >
                    Кол.
                  </TableCell>

                  <TableCell
                    style={{
                      fontSize: smallerFontSize,
                      lineHeigth: '1.1',
                    }}
                    size="small"
                  >
                    За връщане
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {getMaterialsToMap().map(x => (
                  <TableRow key={x.serialNumber || x.materialId}>
                    <TableCell
                      style={{
                        fontSize: smallerFontSize,
                        paddingRight: '1px',
                        lineHeigth: '1.1',
                      }}
                      size="small"
                    >
                      {x.materialName}
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: smallerFontSize,
                        paddingRight: '1px',
                        lineHeigth: '1.1',
                      }}
                      size="small"
                    >
                      {x.materialId}
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: smallerFontSize,
                        paddingRight: '1px',
                        lineHeigth: '1.1',
                      }}
                      size="small"
                    >
                      {x.serialNumber}
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: smallerFontSize,
                        paddingRight: '1px',
                        lineHeigth: '1.1',
                      }}
                      size="small"
                    >
                      {x.quantity}
                    </TableCell>

                    <TableCell
                      style={{
                        fontSize: smallerFontSize,
                        lineHeigth: '1.1',
                      }}
                      size="small"
                    >
                      <ReturnMaterialQuantityInput material={x} {...{ smallerFontSize }} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      )}
    </Dialog>
  );
};

export default ReturnMaterialsDialog;
